/** Save a setup guide as `<base>.md` (spaces → dashes, lower-cased), as every Setup sub-tab offers. */
export function downloadMd(content, base) {
    const blob = new Blob([content], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${base.replace(/\s+/g, '-').toLowerCase()}.md`;
    a.click();
    URL.revokeObjectURL(url);
}
